import { useEffect } from 'react'

import { ApolloError } from '@apollo/client'

import { captureCoralogixError } from '~/modules/coralogix'

const reportedKeys = new Set<string>()

/** Clears the de-duplication cache. Exported for use in tests only. */
export const clearReportedErrors = () => reportedKeys.clear()

/**
 * Reports an Apollo error to Coralogix once per distinct error message.
 * Pass `skip: true` to suppress reporting for expected errors (e.g. 401/404).
 * De-duplicates across all hook instances by `component + message` so multiple
 * mounted components and remounts don't cause repeated Coralogix reports.
 */
export const useCaptureUnexpectedApolloError = (
  error: ApolloError | undefined,
  options: { component: string; skip?: boolean }
) => {
  const { component, skip } = options

  useEffect(() => {
    if (error && !skip) {
      const errorKey = `${component}:${error.message}`
      if (!reportedKeys.has(errorKey)) {
        reportedKeys.add(errorKey)
        captureCoralogixError(error, { component })
      }
    }
  }, [error, component, skip])
}
